export const lowerCapitalize = (s) => {
  if (!s) {
    return '';
  }

  return `${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()}`;
};



// WEBPACK FOOTER //
// ./src/utils/string-utils.js